import React from "react";
import Header1 from "./Header1";
import Header2 from "./Header2";
import Body10 from "./Body10";
import Footer1 from "./Footer1";
import Footer2 from "./Footer2";


function PageProjektyBody10() {

  return (
    <div>
      <Header1/>
      <Header2/>
      <Body10/>
      <Footer1/>
      <Footer2/>
    </div>
  );
}

export default PageProjektyBody10;
